<template>
	<OfMultiSelect
		:name="name"
		:label="label"
		:options="productSpecificationOptions"
		:multiple="multiple"
		@input="$emit('specificationInput', $event)"
	/>
</template>

<script>
import { OfMultiSelect } from '@oneflow/ofs-vue-layout';

export default {
	components: { OfMultiSelect },
	props: {
		label: {
			type: String,
			default() {
				return this.$t('Product Specification');
			}
		},
		name: {
			type: String,
			required: true
		},
		value: {
			type: null
		},
		multiple: {
			type: Boolean,
			default: false
		},
		productSpecificationOptions: {
			type: Array,
			default: () => []
		}
	}
};
</script>
